/**
 * Display name mappings for monitoring categories
 */
export const MONITORING_NAME_MAP: Record<string, string> = {
  digitalocean: 'Digital Ocean',
  digitaloceanResources: 'Digital Ocean Resources',
  ipv4: 'IPv4',
  ipv6: 'IPv6',
  github: 'GitHub',
  gitlab: 'GitLab',
  bitbucket: 'Bitbucket',
  azuredevops: 'Azure DevOps',
  amazon: 'AWS',
  amazonResources: 'AWS Resources',
  azure: 'Azure',
  azureResources: 'Azure Resources',
  gcp: 'GCP',
  gcpResources: 'GCP Resources',
  domain: 'Domains',
  subdomain: 'Subdomains',
  webapplication: 'Web Applications',
  ADDomain: 'AD Domains',
  ADUser: 'AD Users',
  ADComputer: 'AD Computers',
  ADGPO: 'AD GPOs',
  ADOU: 'AD OUs',
  external: 'External Network',
  internal: 'Internal Network',
  resources: 'Cloud Resources',
  cloud: 'Cloud',
  network: 'Network',
  code: 'Code',
  applications: 'Applications',
  internalNetwork: 'Internal Intranet',
  externalNetwork: 'Internet Perimeter',
  webseed: 'Web Coverage',
  webllm: 'LLM Applications',
  llm: 'LLM Applications',
};

/**
 * Tooltip descriptions for monitoring categories
 */
export const MONITORING_TOOLTIP_MAP: Record<string, string> = {
  amazon: 'External assets imported from Amazon cloud infrastructure',
  amazonResources:
    'Internal cloud resources imported from Amazon cloud infrastructure',
  azure: 'External assets imported from Microsoft Azure cloud infrastructure',
  azureResources:
    'Internal cloud resources imported from Microsoft Azure cloud infrastructure',
  gcp: 'External assets imported from Google Cloud Platform infrastructure',
  gcpResources:
    'Internal cloud resources imported from Google Cloud Platform infrastructure',
  digitalocean:
    'External assets imported from DigitalOcean cloud infrastructure',
  digitaloceanResources:
    'Internal cloud resources imported from DigitalOcean cloud infrastructure',
  resources:
    'Cloud resource inventory items (e.g., AWS::EC2::Instance, microsoft.compute/virtualmachines) not included in asset totals',
  ipv4: 'IPv4 addresses discovered through network scanning, excluding direct integration imports',
  ipv6: 'IPv6 addresses discovered through network scanning, excluding direct integration imports',
  domain:
    'Top-level domains discovered through DNS resolution, excluding direct integration imports',
  subdomain:
    'Subdomains discovered through DNS enumeration, excluding direct integration imports',
  github: 'Repositories and assets discovered through GitHub integration',
  gitlab: 'Repositories and assets discovered through GitLab integration',
  bitbucket: 'Repositories and assets discovered through BitBucket integration',
  azuredevops: 'Repositories discovered through Azure DevOps integration',
  ADDomain: 'AD Domains',
  ADUser: 'AD Users',
  ADComputer: 'AD Computers',
  ADGPO: 'AD GPOs',
  ADOU: 'AD OUs',
  webapplication:
    'Live web applications verified through HTTP response analysis. Excludes default server pages, parked domains, and out-of-scope redirects.',
  webseed:
    'Web application seeds manually added or imported for monitoring coverage',
  webllm: 'Web applications with detected LLM or AI services',
  llm: 'Web applications with detected LLM or AI services',
};
